<template>
  <div class="Logout">
    <section-header heading="2" ja="ログアウト確認"/>
    <div class="description">ログアウトしますか？</div>
    <normal-btn @click="onOK">ログアウト</normal-btn>
    <sub-btn @click="onCancel">キャンセル</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import Protobuf from "../mixins/protobuf"
import NormalBtn from '../components/NormalBtn'
import SubBtn from '../components/SubBtn'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Logout",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn,
  },
  mixins: [
    Protobuf
  ],
  methods: {
    onCancel() {
      this.$router.back()
    },
    onOK() {
      const cmdNo = pb.LogoutReq.CommandNo.COMMAND_NO
      const message = pb.LogoutReq.create({
        token: this.$store.getters.token
      })
      const encoded = pb.LogoutReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.LogoutResp.Status.SUCCESS) {
            sessionStorage.setItem('albumFilter', 'ALL')
            sessionStorage.setItem('albumValue', 1)
            sessionStorage.setItem('sheetAlbumValue', 1)
            sessionStorage.setItem('albumTab', 0)
            this.$store.dispatch('logout')
            this.$router.push('/login')
          } else {
            this.$_error('Error', { title: 'プロフィール', statusCode: 413 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
        })
    }
  }
}
</script>

<style scoped>
.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
